import type { IntlShape } from "@formatjs/intl";
import { Card, Col, Flex, Form, Input, Row } from "antd";
import type { Materials } from "../generated-axios-client";
import { MaterialsSelectorFormItem } from "../ticket/create-forms/MaterialsSelectorFormItem";

type ServiceFieldsProps = {
  intl: IntlShape;
  materialItems: Materials[];
};

export const ServiceFields = ({ intl, materialItems }: ServiceFieldsProps) => (
  <Flex vertical gap="middle">
    <Card title={intl.formatMessage({ id: "service_section_details" })}>
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Form.Item
            name="name"
            label={intl.formatMessage({ id: "service_name" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "validation_message_service_name" }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="description"
            label={intl.formatMessage({ id: "service_description" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "validation_message_service_description",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Card>
    <Card title={intl.formatMessage({ id: "service_section_supplies" })}>
      <MaterialsSelectorFormItem intl={intl} materialItems={materialItems} />
    </Card>
  </Flex>
);
